import React from 'react';
import { arrayOf, shape, string, number } from 'prop-types';
import Link from '@magalu/stereo-ui/atoms/Link';
import { routePush } from '@magalu/mixer-utils';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { Container } from './SeoSubcategoryList.styles';
var SeoSubcategoryList = function SeoSubcategoryList(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var subcategories = data == null ? void 0 : data.seoDepartmentSubCategories.data;
  var basePath = structure.basePath;
  var onSubcategoryClick = function onSubcategoryClick(truePath) {
    routePush({
      path: "".concat(basePath).concat(truePath),
      spa: true
    });
  };
  return React.createElement(Container, {
    "data-testid": "ctn-subcategories",
    columns: staticProps.columns
  }, subcategories.map(function (item) {
    var _item$meta2;
    return React.createElement(Link, {
      onClick: function onClick(e) {
        var _item$meta;
        e.preventDefault();
        onSubcategoryClick(item == null ? void 0 : (_item$meta = item.meta) == null ? void 0 : _item$meta.truePath);
      },
      key: item == null ? void 0 : item.id,
      href: "".concat(basePath).concat((item == null ? void 0 : (_item$meta2 = item.meta) == null ? void 0 : _item$meta2.truePath) || ''),
      my: 2,
      as: "a",
      color: "text.primary",
      display: "block",
      style: {
        wordBreak: 'break-all'
      }
    }, item == null ? void 0 : item.h1);
  }));
};
SeoSubcategoryList.ssr = true;
process.env.NODE_ENV !== "production" ? SeoSubcategoryList.propTypes = {
  data: shape({
    seoDepartmentSubCategories: shape({
      data: arrayOf(shape({
        h1: string,
        id: string,
        meta: shape({
          truePath: string
        })
      }))
    })
  }),
  "static": shape({
    columns: number
  }),
  structure: shape({
    basePath: string
  })
} : void 0;
SeoSubcategoryList.defaultProps = {
  data: {
    seoDepartmentSubCategories: {
      data: []
    }
  },
  "static": {
    columns: 4
  },
  structure: {
    basePath: ''
  }
};
SeoSubcategoryList.dataSource = {
  seoDepartmentSubCategories: {
    query: 'seoDepartmentSubCategoriesQuery'
  }
};
export default withLayoutProps(SeoSubcategoryList);